module.exports = __webpack_public_path__ + "img/img-7c3149.png";